import { Model } from 'miragejs';

export default Model.extend({
  company_id: null,
  location_id: null,
  features: null,
});
